import type { ReactNode } from "react";
import { cn } from "@/lib/utils";

const WIDTH_CLASS = {
  form: "max-w-3xl",
  default: "max-w-6xl",
  wide: "max-w-7xl",
} as const;

export type PageContainerWidth = keyof typeof WIDTH_CLASS;

interface PageContainerProps {
  children: ReactNode;
  width?: PageContainerWidth;
  className?: string;
}

/** Shared content shell: width role + vertical rhythm. No extra horizontal padding. */
export function PageContainer({ children, width = "default", className }: PageContainerProps) {
  return (
    <div className={cn("mx-auto w-full space-y-6", WIDTH_CLASS[width], className)}>{children}</div>
  );
}
